module.exports = __webpack_public_path__ + "static/media/venus.06cfea8f.jpg";